import { Route } from "react-router-dom";
import PropTypes from "prop-types";

import { useRedirect } from "hooks";
import UserPresenter from "presenters/UserPresenter";
import CurrentUserSpinner from "components/CurrentUserSpinner";
import { appRoutes } from "routes";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { isCULoadingFinished } = useRedirect(appRoutes.rootPath(), UserPresenter.notRegistered);

  return (
    <Route {...rest} render={(props) => (isCULoadingFinished ? <Component {...props} /> : <CurrentUserSpinner />)} />
  );
};

ProtectedRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
};

export default ProtectedRoute;
